import { Button } from 'antd';
import React, { FC, useEffect, useMemo } from 'react';
// @ts-expect-error разобраться в импорте и работе с SVG
import PicPassport from 'src/assets/passport-pic.svg?react';

import { openNotification } from '../../../common/helpers';
import { NotificationTypes } from '../../../common/interfaces';
import { UploadImg } from '../../../components/UploadImg';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { userApi } from '../../../store/api/user.api';
import { getImgUrl } from '../Documents/Documents.helpers';
import { DocTypeClass } from '../Registration.interfaces';
import styles from './UploadSelfie.module.scss';

type Props = {
  next: () => void;
  prev: () => void;
};

export const UploadSelfie: FC<Props> = ({ next, prev }) => {
  const { userInfo } = useTypedSelector((state) => state.registration);

  const [getFileBase64, { isLoading: loadingDownload }] =
    userApi.useGetFileBase64Mutation();

  const [uploadFile, { isLoading: loadingUploadFile }] =
    userApi.useUploadFileMutation();

  const [deleteFile, { isLoading: loadingDelete }] =
    userApi.useDeleteFileMutation();

  const [imgBlob, setImgBlob] = React.useState<string | null>(null);
  const onSetImgBlob = (imgBlob: string) => {};

  // Ищем файл селфи с паспортом
  const docFileImgData = useMemo(() => {
    if (userInfo && userInfo.docs.length !== 0) {
      return userInfo.docs.find(
        (doc) => doc.docTypeClass === DocTypeClass.PHOTO,
      );
    } else null;
  }, [userInfo]);

  const onRemoveImg = async () => {
    if (docFileImgData) {
      try {
        await deleteFile({ fileId: docFileImgData.fileId as string }).unwrap();
        openNotification(NotificationTypes.SUCCESS, 'Файл удален с сервера');
      } catch (e) {
        console.error(e);
        openNotification(
          NotificationTypes.ERROR,
          `Произошла ошибка при попытке удалить файл: ${e}`,
        );
      }
    }
  };

  const handleSubmit = () => {
    // Если есть картинка в store
    // if (registrationFields.dealProfile === 'sd') {
    //   next();
    // } else {
    //   setErrorImg('Обязательное поле');
    // }
    next();
  };

  useEffect(() => {
    //TODO: Кеширование
    if (docFileImgData) {
      getFileBase64({ fileId: docFileImgData.fileId as string }).then(
        (base64Photo) => {
          if (!base64Photo.data) {
            console.error('No data in "getFileBase64"');
            return;
          }
          const imgUrl = getImgUrl(base64Photo.data);
          setImgBlob(imgUrl);
        },
      );
    }
  }, [docFileImgData, getFileBase64]);

  return (
    <div>
      <h3 className={styles.title}>Селфи с паспортом</h3>
      <div className={styles.picture}>
        <div className={styles['selfie-pic']}>
          <PicPassport />
        </div>

        <UploadImg
          imgBlob={imgBlob}
          onRemoveImg={onRemoveImg}
          uploadImg={uploadFile}
          isLoading={loadingUploadFile || loadingDownload || loadingDelete}
          onSetImg={onSetImgBlob}
        />

        <p>
          Прикрепите фотографию (селфи) директора с документом удостоверяющим
          личность в раскрытом виде
          {/* Прикрепите фотографию (селфи) с документом удостоверяющим личность в
          раскрытом виде */}
          <span>(Файл не должен превышать 300 Кб)</span>
        </p>
      </div>

      <div className={styles['steps-buttons']}>
        <Button
          style={{ width: '102px' }}
          onClick={handleSubmit}
          htmlType="button"
          type="primary"
          size="large"
        >
          Далее
        </Button>
      </div>
    </div>
  );
};
